exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".training-project-session-logs-modal .logs-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.training-project-session-logs-modal .logs-modal-header .logs-title {\n  font-size: 16px;\n  font-weight: 500;\n}\n.training-project-session-logs-modal .logs-modal-header .auto-scroll-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.training-project-session-logs-modal .logs-modal-header .auto-scroll-controls .auto-scroll-label {\n  font-size: 14px;\n}\n", ""]);

// exports
